import React from "react";
import { Link } from "react-router-dom";

import "./Header.css";

export default function Header() {
  return (
    <nav className="Header">
      <Link to="/">Accueil</Link>
      <Link to="/about">À propos</Link>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.referendum.interieur.gouv.fr/soutien/etape-1"
      >
        Signer le référendum pour ADP
      </a>
    </nav>
  );
}
